/*** IMPORTS FROM imports-loader ***/
var define = false;

import tagTester from './_tagTester.js';

export default tagTester('Symbol');




//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isSymbol.js
// module id = 81
// module chunks = 0